import React, { ReactElement, useEffect, useMemo, useRef, useState } from 'react';
import './ComicInfo.scss';
import Tabs from './Tabs/Tabs';
import MoreInfo from '../MoreInfo/MoreInfo';
import { useSkipFirstRender } from '../../../Hooks/useSkipFirstRender';
import Chapters from '../Chapters/Chapters';
import SortArrow from '../../../Assets/icons/SortArrow';
import VolumeTabBar from '../Desktop/DesktopVolume/VolumeTabBar';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import VolumeItem from './Volume/VolumeItem';
import { ProductsForSeriesAtom, SingleSeriesAtom } from '../../../../store/SeriesStore';
import Log from '../../../Services/Logger';
import { useLocation } from 'react-router-dom';

interface SeriesInfoProps {
    renderKodanshaAvailable?: () => JSX.Element;
}


const SeriesInfo = (props: SeriesInfoProps): ReactElement => {
    const series = useAtomValue(SingleSeriesAtom);
    const products = useAtomValue(ProductsForSeriesAtom);

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);

    const [showChapters, setShowChapters] = useState(searchParams.get('showChapters') === "true" ?? false);
    const [isBookSeries, setIsBookSeries] = useState(false);
    const [sortedProducts, setSortedProducts] = useState([]);
    const [sorted, setSorted] = useState(true);
    const volumeRef = useRef(null);

    useEffect(() => {
        setIsBookSeries(series?.isMostlyBooks())
    }, [series]);

    useEffect(() => {
        if(products) {
            setSortedProducts(sorted ? products : products.slice(0).reverse());
        }
    }, [products, sorted]);

    function ListProducts() {
        return sortedProducts?.map((product, index) => {
            return <div  key={index} className={'series-volumeItem'}>
                <VolumeItem key={product.id} product={product} series={series} isFirst={index === 0}
                               index={index}
                               isLast={index === products?.length - 1} showChapters={showChapters} setShowChapters={setShowChapters} />
            </div>;
        });
    }

    const chapterLength = useRef<number | string>(0);
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        chapterLength.current = products ? products.reduce((accumulator, product) => accumulator + (product.chapters ? product.chapters.length : 0), 0) : '';
    }, [products]);

    useSkipFirstRender(() => {
        showChapters && (document.querySelector('html').style.scrollBehavior = 'smooth');
        window.scrollTo(0, volumeRef.current.offsetTop - 95);
        document.querySelector('html').style.scrollBehavior = 'unset';
    }, [showChapters]);

    const sortVolumes = (): void => {
        console.log('sort');
        setSorted(sorted => !sorted);
    };

    const areThereFreeChapters = useMemo(() => {
        return products?.some(volume => {
            return volume?.chapters?.some(chapter => {
                return chapter?.variants[0]?.priceType === 'Free' || chapter?.variants[0]?.priceType === 'FreeForRegistered';
            });
        });
    }, [products]);


    Log.debug('areThereFreeChapters', areThereFreeChapters);
    Log.info("Render SeriesInfo...");

    if (!series || !products) {
        return null; // Don't render before we have what we want. Remove this when preloader is made
    }

    return (
            <div ref={volumeRef} className='series-desktop-volume-container series-products-container'>
                {/*Show on desktop*/}
                {isBookSeries === false && <VolumeTabBar
                    sortVolumes={sortVolumes}
                    volumes={products}
                    sorted={sorted}
                    setShowChapters={setShowChapters}
                    areThereFreeChapters={areThereFreeChapters}
                    showChapters={showChapters}
                    volumeCount={products?.length} />}

                <Tabs items={['Volumes', 'Chapters', 'More Info']} activeTab={activeTab} onTabChange={(active: number) => setActiveTab(active)} />

                {activeTab !== 2 && <div className='sort-wrapper'>
                <span
                    className='sort-text'>
                    {activeTab === 0 ? products?.length + ' Volumes' : chapterLength.current + ' Chapters'}
                </span>

                    <div onClick={sortVolumes}
                         className={`${sorted ? 'sort-icons-wrapper-active' : 'sort-icons-wrapper'}`}>
                        <SortArrow />
                        <SortArrow />
                    </div>
                </div>}

                {activeTab === 0 &&  <div
                    className={`series-desktop-volume-grid ${showChapters && 'series-desktop-volume-grid-show-chapters'}`}>
                    {ListProducts()}
                </div>}
                {activeTab === 1 && <Chapters products={sortedProducts} sorted={sorted} />}
                {activeTab === 2 && <MoreInfo tags={['TAG 1', 'TAG 2', 'TAG 3', 'TAG 4']} synopsis={series?.description} />}

                {/*/!* TODO: Desktop Features *!/*/}
                {/*/!*<Universes />*!/*/}
                {props.renderKodanshaAvailable && props.renderKodanshaAvailable()}
            </div>

    );
};

export default SeriesInfo;
